export default __webpack_public_path__ + "static/media/pic6.f00c8970.webp";